export default __webpack_public_path__ + "static/media/slider_6-xs@1x.154dba00.jpg";